import { ReactNode, forwardRef } from "react";
import EmptyAssetCard from "../../../../common/features/asset/EmptyAssetCard.tsx";
import ListAssetCardContainer from "../../../../common/features/asset/ListAssetCardContainer.tsx";
import { CompositeAsset } from "../../../../common/api/decimal/common-types/manageAssets.ts";
import { unknownPrintSource } from "../../../../common/features/asset/AssetCover.tsx";

interface ListResultCardProps {
  asset: CompositeAsset;
  coverWidth?: string;
  lazyLoad?: boolean;
  children: ReactNode;
  containerClassName?: string;
  cardClassName?: string;
  footerButtons?: ReactNode;
  imageChildren?: ReactNode;
}

function ListResultCard(
  {
    asset,
    coverWidth,
    lazyLoad,
    children,
    containerClassName,
    cardClassName,
    footerButtons,
    imageChildren,
  }: ListResultCardProps,
  ref: React.ForwardedRef<HTMLElement>
) {
  return (
    <ListAssetCardContainer tagName="li" className={containerClassName}>
      <EmptyAssetCard
        type="horizontal"
        vbid={asset.manageAsset.vbid}
        tagName="div"
        lazyLoad={lazyLoad}
        imageChildren={imageChildren}
        horizontalCardImageWidth={coverWidth}
        className={cardClassName}
        imageSource={
          asset.manageAsset.kind.toLowerCase() === "print book"
            ? unknownPrintSource
            : null
        }
        ref={ref}
      >
        {children}
      </EmptyAssetCard>
      {footerButtons}
    </ListAssetCardContainer>
  );
}

const ResultCard = forwardRef<HTMLElement, ListResultCardProps>(ListResultCard);

export default ResultCard;
